
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.634","height":"16.633"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_48148","data-name":"Group 48148","transform":"translate(-.175 -.174)","stroke":"#0d0d0d","stroke-width":"1.5"}},[_c('path',{attrs:{"id":"Path_29935","data-name":"Path 29935","d":"M2.374.75H14.26a1.624 1.624 0 011.624 1.624V14.26a1.623 1.623 0 01-1.624 1.623H2.374A1.623 1.623 0 01.75 14.26V2.374A1.624 1.624 0 012.374.75","transform":"translate(.175 .174)","fill":"#fff"}}),_c('line',{attrs:{"id":"Line_1362","data-name":"Line 1362","y2":"15.133","transform":"translate(6.805 .924)","fill":"none","stroke-linecap":"round"}}),_c('line',{attrs:{"id":"Line_1363","data-name":"Line 1363","x1":"1.951","transform":"translate(2.816 4.195)","fill":"none","stroke-linecap":"round"}}),_c('line',{attrs:{"id":"Line_1364","data-name":"Line 1364","x1":"1.951","transform":"translate(2.816 6.637)","fill":"none","stroke-linecap":"round"}})])])
          )
        }
      }
    